var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SoliForm", {
        ref: "form",
        attrs: {
          title: "Reassign Room",
          imgSrc: "https://kylelamoreaux.github.io/dublin-room.png",
          text: "Save",
          icon: "save",
        },
        on: {
          reset: _vm.reset,
          submit: _vm.submit,
          success: function ($event) {
            return _vm.$emit("success")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex align-center" },
                  [
                    _c("div", { staticClass: "soli-grey flex-1 pt-4 px-3" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            `Move ${_vm.moveTeacher} to ${_vm.roomName}?`
                          ) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.loading
                      ? _c("v-progress-circular", {
                          staticClass: "mx-3",
                          attrs: { indeterminate: "", color: "primary" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.lessons.length
                  ? _c(
                      "v-simple-table",
                      { staticClass: "soli-grey v-sheet--outlined my-4" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "soli-caption soli-grey" },
                              [
                                _vm._v(
                                  "\n                            Affected students:\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticClass: "soli-caption soli-grey" },
                              [_vm._v("Start:")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.loading,
                                expression: "!loading",
                              },
                            ],
                          },
                          _vm._l(_vm.lessons, function (lesson) {
                            return _c("tr", { key: lesson.id }, [
                              _c("td", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(lesson.student?.name) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.globalMomentFullDateAtTime(
                                        lesson.starts_at
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showSelectAssign
        ? _c("SoliForm", {
            ref: "selectAssign",
            attrs: {
              title: "Which assignment?",
              hideBtn: "",
              persistent: "",
              permanent: "",
            },
            on: {
              reset: function ($event) {
                _vm.showSelectAssign = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "v-list",
                        _vm._l(_vm.assignments, function (assignment) {
                          return _c(
                            "v-list-item",
                            { key: assignment.id },
                            [
                              _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  block: "",
                                  text: _vm.globalMomentTime(
                                    assignment.starts_at
                                  ),
                                  color: "soli-grey",
                                  outlined: "",
                                },
                                on: {
                                  click: function ($event) {
                                    ;[
                                      (_vm.selectedAssignment = assignment),
                                      _vm.getAffectedLessons(),
                                      _vm.$refs.selectAssign.reset(),
                                    ]
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2284328049
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.futureConflict
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle: `${
                _vm.futureConflict.roomConflict
                  ? _vm.futureConflict.roomConflict
                  : _vm.assignments[0].teacher.name
              }
                   is already assigned at this time, starting ${_vm.globalMomentDate(
                     new Date(
                       _vm.futureConflict.date || _vm.futureConflict.starts_at
                     )
                   )}. Would you like to move ${
                _vm.assignments[0].teacher.first_name
              }'s assignments anyways?`,
              button1: "Ok",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                ;(_vm.futureConflict = null),
                  (_vm.form.noConflict = true),
                  (_vm.$refs.form.loading = true),
                  _vm.submit()
              },
              option2: function ($event) {
                ;[
                  (_vm.form.noConflict = false),
                  (_vm.$refs.form.loading = false),
                ]
              },
              reset: function ($event) {
                _vm.futureConflict = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMoveInStudioWarning
        ? _c("SoliChoice", {
            attrs: {
              permanent: "",
              title: "Are you sure",
              subtitle: `You are moving this assignment in-studio. ${_vm.selectedAssignment.teacher.first_name}'s lessons will remain online for students. ${_vm.selectedAssignment.teacher.first_name}'s online room will no longer be available.`,
              button1: "I understand",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                ;[_vm.closeModal(() => (_vm.showMoveInStudioWarning = false))]
              },
              reset: function ($event) {
                ;[
                  _vm.closeModal(() => (_vm.showMoveInStudioWarning = false)),
                  (_vm.saveChanges = false),
                ]
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }